import React from 'react'
import styled from 'styled-components'
import FbButton from 'components/FbUI/FbButton'
import { PiDevicesFill } from 'react-icons/pi'

const Container = styled.div`
  padding: 24px;
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const Header = styled.div`
  font-size: 24px;
  font-weight: 600;
`

const SubHeader = styled.div`
  font-size: 18px;
  font-weight: 400;
  color: #6e6e6e;
`

const MobileNotReady: React.FC = () => {
  return (
    <Container>
      <div className="flex flex-col">
        <div className="text-gray-300 text-5xl flex justify-center">
          <PiDevicesFill />
        </div>
        <Header>{"This page isn't ready for mobile yet."}</Header>
      </div>

      <SubHeader>Please view on desktop. </SubHeader>
      <div className="flex justify-center">
        <FbButton variant="primary-outline">Explore Options</FbButton>
      </div>
    </Container>
  )
}

export default MobileNotReady
